<template>
  <div>
    <list
      row-key="SettleDocId"
      ref="list"
      unit="冲销单"
      light-row
      @row-select="x=>$emit('change', x)"
      :page="page"
      :queryParamsAppend="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="冲销类型" label-width="100px">
          <el-select v-model="params.CancelTypeId" @change="typeChange" placeholder="请选择">
            <el-option label="预收冲应收" :value="0"></el-option>
            <el-option label="预付冲应付" :value="1"></el-option>
            <el-option label="应收冲应收" :value="2"></el-option>
            <el-option label="应付冲应付" :value="3"></el-option>
            <el-option label="应收冲应付" :value="4"></el-option>
            <el-option label="应付冲应收" :value="5"></el-option> <!--hqq-->
          </el-select>
        </el-form-item>
        <el-form-item label="单据编号" label-width="100px">
          <el-input clearable v-model="params.DocNo" placeholder="请输入单据编号" />
        </el-form-item>
        <el-form-item label="单据日期" v-if="!isMB" label-width="100px">
          <range-picker
            :date="[params.DocDateStart, params.DocDateEnd]"
            @change="x=>{params.DocDateStart=x.Start;params.DocDateEnd=x.End;}"
            style="min-width:200px"
          />
        </el-form-item>
        <!-- <el-form-item label="冲销单据日期" v-if="!isMB" label-width="100px">
          <range-picker
            :date="[params.DocDateStart, params.DocDateEnd]"
            @change="x=>{params.DocDateStart=x.Start;params.DocDateEnd=x.End;}"
          />
        </el-form-item> -->
        <el-form-item label="往来单位" label-width="100px">
          <select-input
            placeholder="请选择单位"
            :label="params.TradeUnitName"
            v-model="params.TradeUnitId"
            @click="openTradeunit"
          />
        </el-form-item>

      </template>
      <template slot="table">
        <!-- <el-table-column prop="DocNo" label="单据编号" min-width="110" />
        <el-table-column prop="DocDate" label="单据日期" min-width="100">
          <template slot-scope="{row}">{{ $commonJs.toDateString(row.DocDate) }}</template>
        </el-table-column>
        <el-table-column prop="CancelTypeId" label="冲销类型" min-width="100">
          <template slot-scope="{row}">
            <span v-if="row.CancelTypeId==0">预收冲应收</span>
            <span v-if="row.CancelTypeId==1">预付冲应付</span>
            <span v-if="row.CancelTypeId==2">应收冲应收</span>
            <span v-if="row.CancelTypeId==3">应付冲应付</span>
            <span v-if="row.CancelTypeId==4">应收冲应付</span>
          </template>
        </el-table-column>
        <el-table-column :label="tbLabel" min-width="130" show-overflow-tooltip>
          <template slot-scope="{row}">{{row.FirstUnitName}}</template>
        </el-table-column>
        <el-table-column v-if="showSecond" label="转入结算单位" min-width="130" show-overflow-tooltip>
          <template slot-scope="{row}">{{row.SecondUnitName}}</template>
        </el-table-column>
        <el-table-column prop="CurrentTotalAmount" label="冲销金额" />
        <el-table-column prop="ClerkName" label="经办人" />
        <el-table-column prop="Memo" label="备注" min-width="140" /> -->
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <tradeunit-dialog ref="tradeunitDialog" selectable @select="setTradeunit" />
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import tradeunitDialog from "@/components/basedata/business/come/listDialog";

export default {
  mixins: [listMixin],
  components: { list, tradeunitDialog },
  props: {
    showCheckbox: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    tbLabel() {
      if (this.params.CancelTypeId < 2) return "往来单位";
      else return "转出结算单位";
    },
    showSecond() {
      return this.params.CancelTypeId > 1;
    },
  },
  data() {
    return {
      api: require("@/api/rp/rpSettleDoc").default,
      params: {
        CancelTypeId: 0, //预收冲应收、预付冲应付、应收冲应收、应付冲应付、应收冲应付
        TradeUnitId: null,
        TradeUnitName: "",
        // BusinessTypeId: null,
        DocNo: null,
        DocDateStart:'', //单据日期
        DocDateEnd: '', //单据日期
      },
      isMB: this.$store.state.isMB,
    };
  },
  mounted() {
    if (!this.$permission.canPrice("/finance/dealings/chargeoff")) {
      const list = this.$refs.list;
      const findIndex = list.tableList.findIndex(item => item.tableName == "CurrentTotalAmount");
      if (findIndex >= 0) list.tableList.splice(findIndex, 1);
    }
  },
  activated(){
    this.getRouterInfo()
  },
  methods: {
    getRouterInfo(){
      if(this.$router.history.current.params){
        this.params.DocNo= this.$router.history.current.params.DocNo
        this.$refs.list.getData()
      }   
    },
    typeChange(type) {
      this.$emit("type-change", type);
      this.query();
    },
    openTradeunit() {
      this.$refs.tradeunitDialog.open().then((that) => {
        that.getData();
      });
    },
    setTradeunit(data) {
      this.params.TradeUnitId = data.TradeUnitId;
      this.params.TradeUnitName = data.FullName;
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.$emit("reload");
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
  },
};
</script>